import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import * as types from '../../actions/actionTypes';
import { goToSewpat } from '../../actions/navigation';
import { getActiveSewpatId, getSewpats } from '../../reducers/sewpats';

import SewpatCard from '../sewpat/SewpatCard';

const SewpatGalleryEmbed = ({ sewpats, activeSewpatId, dispatch, omitActive }) => {
    const Gallery = styled.div`
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(18em, 1fr));
        grid-gap: ${props => props.theme.space[11]};
        margin: 0 1em 0 0.5em;

        & .sewpat-card {

        }

    `;

    const handleLearnMore = sewpatID => dispatch(goToSewpat(sewpatID));
    const handleDesignSelect = sewpatId => {
        dispatch({
            type: types.SEWPAT_SELECTED,
            sewpatId,
        });
        dispatch({
            type: types.NAVIGATED_TO_SEWPAT_PATTERN_GALLERY,
            payload: {
                sewpatId,
                slug: 'pattern',
            },
        });
    };

    const activeSewpat = sewpats[activeSewpatId];

    const buildSewpatCards = () => {
        const sewpatCards = Object.keys(sewpats).map(sewpatId => {
            if (sewpatId == activeSewpatId && omitActive) {
                return null;
            }
            return (
            [
                <SewpatCard
                    key={sewpatId}
                    className='sewpat-card'
                    sewpat={sewpats[sewpatId]}
                    handleLearnMore={handleLearnMore}
                    handleDesignSelect={handleDesignSelect}
                />]
            );
        });
        return sewpatCards;
    };

    return (
        <Gallery>
            {buildSewpatCards()}
        </Gallery>
    );
};

const makeMapStateToProps = (initialstate, ownProps) => {
    const sewpats = getSewpats(initialstate);
    const omitActive = ownProps.omitActive;
    const mapStateToProps = state => (
        {
            sewpats,
            activeSewpatId: getActiveSewpatId(state),
            omitActive,
        }
    );
    return mapStateToProps;
};

export default connect(makeMapStateToProps)(SewpatGalleryEmbed);



// WEBPACK FOOTER //
// ./src/components/sewpatgallery/SewpatGalleryEmbed.js